<template>
    <PortalTable ref="transplant_centers_organ_index" table-id="transplant_centers_organ_index"
      :table-data="transplant_center_configurations"
      :loading="loading"
      :filter-values="filterValues"
      filter-display="row"
      sort-field="organ_group.name"
      :sort-order="1"
      mode="local"
      empty="No TXC organ configurations found!"
      @on-filter-change="onFilterChange">
      <template #headers>
        <div class="card-header media" style="display: flex; align-items: center">
          <div class="media-left">
            <div>
              <h4 class="card-title d-flex">
                Txc Organ Config
              </h4>
            </div>
          </div>
        </div>
      </template>
      <template #columns>
        <Column field="organ_group.name" 
          header="Organ" 
          filter-field="organ_group.name"
          :show-filter-menu="false"
          :filter-menu-style="{ width: '15rem' }">
          <template #filter>
            <MultiSelectFilter ref="organ_group_id" 
              filter-field="organ_group.name"
              class="form-control form-control-select"
              option-value="name"
              option-label="name"
              :options="selectedOrganGroups"
              @change="onChangeFilter" />
          </template>
        </Column>
        <Column field="fdCalculationAutoApproval" header="FD Calculation Auto Approval">
          <template #body="slotProps">
            <input :id="`fd-calc-${slotProps.data.id}`" 
              v-model="slotProps.data.config.fd_calculation_auto_approval" 
              type="checkbox"
              class="form-check-input" 
              @input="setDirty()">
          </template>
        </Column>
      </template>
    </PortalTable>

    <ActionToolbar primary-button-text="Update Organ Config" 
      :component-state="currentState" :success-message="successMessage"
      :primary-disabled="!dirty"
      :error-message="formError" :secondary-enabled="false" @primary-click="updateOrganConfig" />
</template>
<script>
import PortalTable from "@/src/components/shared/PortalTable.vue";
import Column from 'primevue/column';
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import ActionToolbar from "@/src/components/shared/ActionToolbar.vue";
import MultiSelectFilter from "@/src/components/shared/FormComponents/MultiSelectFilter.vue";
import { FilterMatchMode } from '@primevue/core/api';
import { useTxcStore } from '@/src/stores/transplant_centers';

export default {
  components: {
    PortalTable,
    Column,
    ActionToolbar,
    MultiSelectFilter,
  },
  mixins: [savableStateMixin],
  props: {
    transplant_center_configurations: { default: () => [], required: true, type: Array },
    loading: { required: true, type: Boolean },
  },
  setup() {
    const txcStore = useTxcStore();
    return { txcStore };
  },
  data() {
    return {
      successMessage: null,
      dirty: false,
      fdCalculationAutoApproval: null,
      filterValues: {
        "organ_group.name" : { value: null, matchMode: FilterMatchMode.IN },
      }
    }
  },
  computed: {
    selectedOrganGroups() {
      if(!this.transplant_center_configurations) return null;

      return this.transplant_center_configurations.map((item) => {
        return { name: item.organ_group.name }
      })
    },
  },

  methods: {
    setDirty() {
      this.dirty = true;
    },
    async updateOrganConfig() {
      this.setSavableStateProcessing();
      this.successMessage = null;
      try {
        let payload = [];

        this.transplant_center_configurations.forEach((record) => {
          payload.push({
            id: record.id,
            transplant_center_id: record.transplant_center_id,
            organ_group_id: record.organ_group_id,
            config: record.config
          });
        });
        
        await this.txcStore.updateTxcConfigurations(payload,this.$route.params.id);
        this.dirty = false;
        this.successMessage = "Successfully updated Txc config!"
        this.setSavableStateSuccess();
      } catch(error) {
        this.handleFormError(error);
      }
    },
    onChangeFilter(event) {
      this.$refs.transplant_centers_organ_index.resetFilters(event);
    }, 
    onFilterChange(event) {
      if(event["organ_group.name"] === "") this.$refs.organ_group_id.clearFilters();
    }
  }
}
</script>